import { cloneDeep } from "lodash-es";
import { ResultRow } from "../../data-structures/results/result-row.model";

interface NPKAnalysisInterface {
 'RESULTS.DATA.TECHNICAL.MFR'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.TS'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.NCWB'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.PCWB'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.KCWB'?: ResultRow;
 'RESULTS.DATA.TECHNICAL.ANCWB'?: ResultRow;
}
export class NPKAnalysis {
  'RESULTS.DATA.TECHNICAL.MFR';
  'RESULTS.DATA.TECHNICAL.TS';
  'RESULTS.DATA.TECHNICAL.NCWB';
  'RESULTS.DATA.TECHNICAL.PCWB';
  'RESULTS.DATA.TECHNICAL.KCWB';
  'RESULTS.DATA.TECHNICAL.ANCWB';

  /** mass flow rate */
  get mfr() {
    return this['RESULTS.DATA.TECHNICAL.MFR']
  }
  set mfr(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.MFR'] = value;
  }
  /** total solid */
  get ts() {
    return this['RESULTS.DATA.TECHNICAL.TS']
  }
  set ts(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.TS'] = value;
  }
  /** nitrogen content (wet basis) */
  get ncwb() {
    return this['RESULTS.DATA.TECHNICAL.NCWB']
  }
  set ncwb(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.NCWB'] = value;
  }
  /** phosphorus content (wet basis) */
  get pcwb() {
    return this['RESULTS.DATA.TECHNICAL.PCWB']
  }
  set pcwb(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.PCWB'] = value;
  }
  /** potassium content (wet basis) */
  get kcwb() {
    return this['RESULTS.DATA.TECHNICAL.KCWB']
  }
  set kcwb(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.KCWB'] = value;
  }
  /** ammonia-nitrogen content (wet basis) */
  get ancwb() {
    return this['RESULTS.DATA.TECHNICAL.ANCWB']
  }
  set ancwb(value: ResultRow) {
    this['RESULTS.DATA.TECHNICAL.ANCWB'] = value;
  }

  constructor(param: NPKAnalysisInterface = {}) {
    this['RESULTS.DATA.TECHNICAL.MFR'] = param['RESULTS.DATA.TECHNICAL.MFR']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.MFR'])
      : new ResultRow();

    this['RESULTS.DATA.TECHNICAL.TS'] = param['RESULTS.DATA.TECHNICAL.TS']
      ? new ResultRow(param['RESULTS.DATA.TECHNICAL.TS'])
      : new ResultRow();

    if (param['RESULTS.DATA.TECHNICAL.NCWB']) {
      this['RESULTS.DATA.TECHNICAL.NCWB'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.NCWB']);
    }

    if (param['RESULTS.DATA.TECHNICAL.PCWB']) {
      this['RESULTS.DATA.TECHNICAL.PCWB'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.PCWB']);
    }

    if (param['RESULTS.DATA.TECHNICAL.KCWB']) {
      this['RESULTS.DATA.TECHNICAL.KCWB'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.KCWB']);
    }

    if (param['RESULTS.DATA.TECHNICAL.ANCWB']) {
      this['RESULTS.DATA.TECHNICAL.ANCWB'] = new ResultRow(param['RESULTS.DATA.TECHNICAL.ANCWB']);
    }
  }

  deepCopy() {
    return new NPKAnalysis(cloneDeep(this));
  }
}